import { toKebabCase } from '@Utils/to-kebab-case';

const Module = {
    state: {
        activeBreadcrumb: ''
    },
    initBasic: function($el) {
        $el = $el || $('.js-datatable-basic');
        
        $el.each(function() {
            var $me = $(this); 
            var columnSort = [];

            $me.find('thead tr th').each(function() {
                if($(this).hasClass('js-disable-sort')) {
                    columnSort.push({ "bSortable": false });
                } else {
                    columnSort.push({ "bSortable": true }); 
                }
            });

            $me.DataTable({
                "aoColumns": columnSort,
                "bFilter": $me.data('hide-search-box') ? false : true,
                "paging": $me.data('hide-paging') ? false : true,
                "info": $me.data('hide-info') ? false : true
            });
        });
    },        
    initAjax: function($el) {
        $el = $el || $('.js-datatable-ajax');
        
        $el.each(function() {
            var $me = $(this);
            var currentDisplayLength = 25;
            var showSearchBox = true;
            var showButtons = true;
            var showPagination = true;
            var columnSort = [];

            if ($me.hasClass('pagination-1')) currentDisplayLength = -1;
            else if ($me.hasClass('pagination-100')) currentDisplayLength = 100;
            else if ($me.hasClass('pagination-50')) currentDisplayLength = 50;
            else if ($me.hasClass('pagination-25')) currentDisplayLength = 25;
            else if ($me.hasClass('pagination-10')) currentDisplayLength = 10;

            if ($me.hasClass('hide-search-box')) showSearchBox = false;
            if ($me.hasClass('hide-buttons')) showButtons = false;
            if ($me.hasClass('hide-pagination')) showPagination = false;

            $me.find('thead tr th').each(function() {
                if($(this).hasClass('js-disable-sort')) {
                    columnSort.push({ "bSortable": false });
                } else {
                    columnSort.push({ "bSortable": true }); 
                }
            });

            var currentSettings = {  
                "sPaginationType": "full_numbers",
                "aLengthMenu": [
                    [10, 25, 50, 100],
                    [10, 25, 50, 100] // change per page values here
                ],
                "iDisplayLength": currentDisplayLength,
                "aoColumns": columnSort,
                "aaSorting": [], // disable initial sorting 
                "bProcessing": true,
                "bServerSide": true,
                "bFilter": showSearchBox,
                "sAjaxSource": $me.data('source')
            };

            if (!showButtons) {
                currentSettings.buttons = {buttons:[]};
            }

            if (!showPagination) {
                currentSettings.bPaginate = false;
            }

            $me.dataTable(currentSettings); 

            var loader = new ciBodyLoader();
            loader.init({
                id: $me.attr('id') + '-loader',
                parentSelector: '#' + $me.parents('.dataTables_wrapper').attr('id'),
                resizeToParent: true
            });

            $me.on('order.dt', function () {
                loader.show();
            });

            $me.on('draw.dt', function () {
                loader.hide();
                $(document).trigger('ci_DataTablesDrawCompleted');
            });
        });
    },
    initSelect2: function($el) {
        /* Select2 for length menu styling */
        $el = $el || $('.dataTables_length select');
        
        $el.select2({
            minimumResultsForSearch: Infinity,
            dropdownAutoWidth: true,
            width: 'auto'
        });
    }
};

Module.setDefaults = function(defaults) {
    defaults = defaults || {
        autoWidth: false,
        searchDelay: 1000,
        dom: '<"datatable-header"fBl><"datatable-scroll-wrap"t><"datatable-footer"ip>',
        buttons: {            
            buttons: [
                {
                    extend: 'copyHtml5',
                    className: 'btn btn-light',
                    exportOptions: {
                        columns: ':visible'
                    },
                    title: Module.state.activeBreadcrumb
                },
                {
                    extend: 'excelHtml5',
                    className: 'btn btn-light',
                    filename: toKebabCase(Module.state.activeBreadcrumb),
                    exportOptions: {
                        columns: ':visible'
                    },
                    title: Module.state.activeBreadcrumb
                },
                {
                    extend: 'csvHtml5',
                    className: 'btn btn-light',
                    filename: toKebabCase(Module.state.activeBreadcrumb),
                    exportOptions: {
                        columns: ':visible'
                    },
                    title: Module.state.activeBreadcrumb
                },
                {
                    extend: 'pdfHtml5',
                    className: 'btn btn-light',
                    filename: toKebabCase(Module.state.activeBreadcrumb),
                    exportOptions: {
                        columns: ':visible'
                    },
                    title: Module.state.activeBreadcrumb
                },
                {
                    extend: 'colvis',
                    text: '<i class="icon-three-bars"></i>',
                    className: 'btn bg-custom btn-icon dropdown-toggle'
                }
            ]
        },
        bStateSave: true,
        stateSaveCallback: function (settings, data) {
            localStorage.setItem(settings.sTableId, JSON.stringify(data));
        },
        stateLoadCallback: function (settings) {
            return JSON.parse(localStorage.getItem(settings.sTableId));
        },
        language: {
            processing: "Verarbeitung läuft...",
            search: "<span class=\"d-none d-lg-inline\">Suchen:</span>",
            searchPlaceholder: "",
            lengthMenu: "<span>Anzeigen</span> _MENU_",
            info: "Einträge von _START_ bis _END_ z _TOTAL_ aus insgesamt",
            infoEmpty: "Einträge 0 von 0 verfügbar",
            infoFiltered: "(Filterung aus _MAX_ verfügbaren Einträgen)",
            infoPostFix: "",
            loadingRecords: "Laden läuft...",
            zeroRecords: "Keine passenden Einträge gefunden",
            emptyTable: "Keine Daten",
            buttons: {
                copy: 'Kopieren',
                copySuccess: {
                    _: "In die Zwischenablage kopiert"
                },
                copyTitle: ''
            },
            paginate: { 
                first: 'Erste',
                last: 'Letzte',
                next: $('html').attr('dir') == 'rtl' ? '&larr;' : '&rarr;',
                previous: $('html').attr('dir') == 'rtl' ? '&rarr;' : '&larr;' 
            },
            aria: {
                sortAscending: ": Aktivieren, um die Spalte aufsteigend zu sortieren",
                sortDescending: ": Aktivieren, um die Spalte absteigend zu sortieren"
            }
        } 
    };
    
    $.extend($.fn.dataTable.defaults, defaults);
};

Module.init = function() {
    //Module.state.activeBreadcrumb = $('#breadcrumbs').find('.breadcrumb-item.active').text();
    Module.setDefaults();
    Module.initBasic();
    Module.initAjax();
    //Module.initSelect2();
};

export const DataTables = Module;